/**
 * @CODE:ACC-003-SKELETON-001
 * AccommodationDetailSkeleton Component
 *
 * Loading skeleton for accommodation detail page:
 * - Image gallery skeleton
 * - Header skeleton
 * - Amenities skeleton
 * - Tabs skeleton
 * - Smooth loading animation
 */

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Skeleton loader for accommodation detail page
 * Shows animated placeholder while data is loading
 */
export const AccommodationDetailSkeleton = () => {
  return (
    <div className={cn("w-full bg-white")}>
      <div className="flex flex-col">
        {/* Image Gallery Skeleton */}
        <section className="w-full">
          <Skeleton className="w-full h-96 rounded-none" />
        </section>

        {/* Header Skeleton */}
        <section className="w-full border-b">
          <div className="container mx-auto px-4 py-6 sm:py-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              {/* Left: Name, Type, Location */}
              <div className="space-y-3">
                <Skeleton className="h-8 w-24" />
                <Skeleton className="h-10 w-2/3" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-1/2" />
                  <Skeleton className="h-4 w-full" />
                </div>
              </div>

              {/* Right: Price and Actions */}
              <div className="space-y-4">
                <Skeleton className="h-20 w-full" />
                <div className="flex gap-3">
                  <Skeleton className="h-10 flex-1" />
                  <Skeleton className="h-10 flex-1" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Amenities Skeleton */}
        <section className="w-full bg-gray-50 border-b">
          <div className="container mx-auto px-4 py-6 sm:py-8">
            <Skeleton className="h-10 w-32 mb-6" />
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {[...Array(8)].map((_, i) => (
                <Skeleton key={i} className="h-20 w-full" />
              ))}
            </div>
          </div>
        </section>

        {/* Tabs Skeleton */}
        <section className="w-full">
          <div className="w-full">
            {/* Tab List Skeleton */}
            <div className="flex gap-4 border-b px-4">
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} className="h-12 w-20" />
              ))}
            </div>

            {/* Tab Content Skeleton */}
            <div className="container mx-auto px-4 py-6 sm:py-8">
              <div className="space-y-4">
                {[...Array(4)].map((_, i) => (
                  <Skeleton key={i} className="h-20 w-full" />
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
